export default "__VITE_ASSET__134031f1__"